/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MetalInputs */

const en_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const ar_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#أجهزة`)
};

const bn_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const de_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const es_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const fr_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const pt_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const zh_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const tr_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const ru_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

const pl_svtag_metal = /** @type {(inputs: Svtag_MetalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#METAL`)
};

/**
* | output |
* | --- |
* | "#METAL" |
*
* @param {Svtag_MetalInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_metal = /** @type {((inputs?: Svtag_MetalInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MetalInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_metal(inputs)
	if (locale === "bn") return bn_svtag_metal(inputs)
	if (locale === "de") return de_svtag_metal(inputs)
	if (locale === "es") return es_svtag_metal(inputs)
	if (locale === "fr") return fr_svtag_metal(inputs)
	if (locale === "pt") return pt_svtag_metal(inputs)
	if (locale === "zh") return zh_svtag_metal(inputs)
	if (locale === "tr") return tr_svtag_metal(inputs)
	if (locale === "ru") return ru_svtag_metal(inputs)
	if (locale === "pl") return pl_svtag_metal(inputs)
	return en_svtag_metal(inputs)
});